import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faTrash } from "@awesome.me/kit-70c1f0055f/icons/duotone/solid";

import { CC_LIST_CARD_SHELL } from "@/components/case-checking/caseCheckingChrome";
import { MissionControlCard } from "@/components/mission-control/MissionControlCard";
import { Button } from "@/components/ui/button/Button";
import type { DocumentAdditionQueueItem } from "@/services/api/case-checking";

export function CaseDocumentQueueRow({
  item,
  classificationLabel,
  disabled,
  onRemove,
}: {
  item: DocumentAdditionQueueItem;
  classificationLabel?: string | null;
  disabled?: boolean;
  onRemove: () => void;
}) {
  const sourceLabel = item.kind === "progeny" ? "CRM" : "Upload";

  return (
    <MissionControlCard
      className={clsx(CC_LIST_CARD_SHELL, "border-dashed border-slate-600/40 bg-slate-900/20")}
      icon={
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-800/80 text-slate-400">
          <FontAwesomeIcon icon={faFile} className="h-4 w-4" />
        </div>
      }
      title={item.label}
      subtitle={
        <span className="inline-flex flex-wrap items-center gap-1.5 mt-1">
          <span className="rounded-full bg-amber-500/15 px-2 py-0.5 text-[11px] font-medium text-amber-200/90 ring-1 ring-amber-500/25">
            Queued
          </span>
          <span className="rounded bg-slate-800 px-1.5 py-0.5 text-[11px] uppercase text-slate-400">{sourceLabel}</span>
          {classificationLabel ? (
            <span className="text-[11px] text-slate-500">{classificationLabel}</span>
          ) : null}
        </span>
      }
      status={
        <Button
          color="slate"
          type="button"
          className="!h-8 !w-8 shrink-0 !p-0"
          disabled={disabled}
          icon={<FontAwesomeIcon icon={faTrash} className="h-3.5 w-3.5" />}
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          aria-label={`Remove ${item.label} from queue`}
          data-testid={`document-queue-remove-${item.id}`}
        />
      }
    />
  );
}
